import { render, staticRenderFns } from "./widgets-header.vue?vue&type=template&id=31c9f97a&scoped=true"
import script from "./widgets-header.vue?vue&type=script&lang=js"
export * from "./widgets-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c9f97a",
  null
  
)

export default component.exports